export default __webpack_public_path__ + "static/media/giraffe.6bdceba5.gif";